import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/views/index'

Vue.use(Router)

export default new Router({
  mode:"history",
  // base: 'ddcp-website',
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/views/index'),
    },
    {
      path: '/app',
      name: 'APP',
      component: () => import('@/views/app'),
    },
    {
      path: '/yundai',
      name: 'yundai',
      component: () => import('@/views/yundai')
    },
    {
      path: '/dianyun',
      name: 'yundai',
      component: () => import('@/views/dianyun')
    }
  ]
})
